"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var HeaderHelper = /** @class */ (function () {
    function HeaderHelper() {
    }
    HeaderHelper.getByKey = function (headers, key) {
        var lowerKey = key.toLocaleLowerCase();
        for (var _i = 0, headers_1 = headers; _i < headers_1.length; _i++) {
            var _a = headers_1[_i], header = _a[0], value = _a[1];
            if (header.toLocaleLowerCase() === lowerKey) {
                return value;
            }
        }
        return undefined;
    };
    HeaderHelper.isJson = function (responseHeaders) {
        var headerValue = this.getByKey(responseHeaders, 'content-type') || '';
        return headerValue.indexOf('application/json') !== -1;
    };
    return HeaderHelper;
}());
exports.HeaderHelper = HeaderHelper;
//# sourceMappingURL=headerHelper.js.map